import useFlexData from '../../hooks/flexHooks/useFlexData';

/**
 * Component that loads all products data when mounted
 * This component doesn't render anything, it just fetches the data
 */
export const FlexDataLoader = () => {
  useFlexData();

  return null;
};

export default FlexDataLoader;
